import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { StyleSheet } from 'aphrodite';
import styled from '@emotion/styled';
import { fromThemeColors, ThemeColor } from '@sharefiledev/flow-web';
export var styles = StyleSheet.create({
  fileCount: {
    marginRight: '5px'
  },
  clearAll: {
    marginLeft: '15px'
  },
  addMore: {
    marginLeft: '250px !important;',
    color: 'blue !important;'
  },
  addMoreButton: {
    textDecoration: 'none !important;'
  }
});
export var StyledFileListInfo = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tborder-bottom: 1px solid ", ";\n\tjustify-content: space-between;\n\tpadding-bottom: 10px;\n\tmargin-bottom: 10px;\n"])), fromThemeColors(ThemeColor.border));